import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationGU from './locales/gu/translation.json';

// Function to get the preferred language from localStorage or user preferences
const getPreferredLanguage = () => {
  try {
    // First, try to get from localStorage (user's saved preference)
    const currentUser = JSON.parse(localStorage.getItem('CurrentUser'));
    if (currentUser?.preferredLanguage) {
      return currentUser.preferredLanguage;
    }
    
    // Fallback to browser language detection
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && (browserLang.startsWith('gu') || browserLang.startsWith('en'))) {
      return browserLang.startsWith('gu') ? 'gu' : 'en';
    }
    
    // Default fallback
    return 'en';
  } catch (error) {
    console.warn('Error getting preferred language:', error);
    return 'en';
  }
};

i18n
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: translationEN
            },
            gu: {
                translation: translationGU
            }
        },
        lng: getPreferredLanguage(), // Use the preferred language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            // Disable automatic language detection to use our custom logic
            order: [],
            caches: ['localStorage']
        }
    });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  try {
    const currentUser = JSON.parse(localStorage.getItem('CurrentUser'));
    if (currentUser) {
      currentUser.preferredLanguage = lng;
      localStorage.setItem('CurrentUser', JSON.stringify(currentUser));
    }
  } catch (error) {
    console.warn('Error saving language preference:', error);
  }
});

export default i18n;
